import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GanttPage } from '../../features/gantt/gantt-page.tsx';
import { parseGanttSearch, type GanttSearch } from '../../features/gantt/search.ts';
import { guardSection } from '../../shell/guard.ts';

// Gantt and milestones (T31). Filters and zoom are URL search params (constitution §5.6).
export const Route = createFileRoute('/_authed/gantt')({
  beforeLoad: guardSection('/gantt'),
  validateSearch: (raw: Record<string, unknown>): GanttSearch => parseGanttSearch(raw),
  component: GanttRoute,
});

function GanttRoute(): React.JSX.Element {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: '/gantt' });
  return (
    <GanttPage
      search={search}
      onSearch={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
